/** @module csi/view/QuerySizeController */
define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		/**
		 * Assign new value to querySize and redraw
		 */
		process: function() {
			var self = this;
			
			this.widget.set(this.actionValue);
			
			this.when(this.widget.redrawData(), function() {
				self.postProcess(true);
			});
		}
	});
});